import React from 'react';
import { Translate } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import ProjectList from '../projectList';
import CreateProjectButton from '../buttons/createProjectButton';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ProjectsView = props => {
  const content = props.projectsError ? /*#__PURE__*/_jsx("span", {
    "data-id": "error-message",
    children: /*#__PURE__*/_jsx(Translate, {
      value: "error.generic"
    })
  }) : /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("div", {
      className: "card col-12",
      children: /*#__PURE__*/_jsx(ProjectList, {
        organisations: props.organisations,
        projects: props.projects,
        projectsCount: props.projectsTotalCount,
        onPageChange: props.onPageChange,
        pageNumber: props.pageNumber,
        pageSize: props.pageSize,
        loading: props.projectsLoading
      })
    })
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "row mt-4 mb-5",
      children: [/*#__PURE__*/_jsxs("h1", {
        "data-id": "project-count",
        className: "col-md-6 m-0",
        children: [/*#__PURE__*/_jsx(Translate, {
          value: "project.projects"
        }), /*#__PURE__*/_jsx("span", {
          className: "separator information",
          children: props.projectsTotalCount
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "col-md-6 inline-container flex-end",
        children: /*#__PURE__*/_jsx(CreateProjectButton, {})
      })]
    }), content]
  });
};
ProjectsView.propTypes = {
  organisations: PropTypes.array.isRequired,
  projects: PropTypes.array.isRequired,
  projectsTotalCount: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  projectsLoading: PropTypes.bool.isRequired,
  projectsError: PropTypes.bool.isRequired
};
export default ProjectsView;